import { cn } from '@/lib/cn';

export function Card({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'grid gap-2 rounded-lg bg-raised p-4 shadow-card',
        // כרטיס בתוך קישור או כפתור הוא לחיץ, ולכן נדלק בריחוף
        'transition-[box-shadow,transform] [a:hover_&]:-translate-y-px [a:hover_&]:ring-2 [a:hover_&]:ring-olive',
        '[button:hover_&]:-translate-y-px [button:hover_&]:ring-2 [button:hover_&]:ring-olive',
        className,
      )}
      {...props}
    />
  );
}

export function CardTitle({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h2
      className={cn('m-0 font-display text-display-m font-semibold', className)}
      {...props}
    />
  );
}

export function CardMeta({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('m-0 text-body-sm text-muted', className)} {...props} />;
}
